import { Activity, ActivityFeedScope } from '@api/activityApi/interfaces';

export const activityMatchesFeedScope = (
  activity: Activity,
  feedScope: ActivityFeedScope | null | undefined
): boolean => {
  if (!feedScope) {
    return true;
  }

  return activity.scopes?.includes(feedScope) ?? false;
};
